module.exports = __webpack_public_path__ + "static/media/mpds_errr-illustration.ecb5f16d.svg";